import { selectManageAccessDraft, selectManageAccessInternalUsers } from '@/store/selectors/manageAccess';
import { setManageAccessDraftField } from '@/store/slices/manageAccess/manageAccessSlice';
import { usePersonPicker } from '@/hooks/shared/usePersonPicker';

export function useStepManageAccessMembers() {
  const { state, handlers } = usePersonPicker({
    selectDraft: selectManageAccessDraft,
    selectUsers: selectManageAccessInternalUsers,
    dispatchSetField: (dispatch, key, value) => dispatch(setManageAccessDraftField({ key, value })),
    primaryKey: 'internalParticipantIds',
    exclusionKey: 'ownerIds',
  });

  return {
    state: {
      selectedMembers: state.selected,
      candidateMembers: state.candidates,
      searchValue: state.searchValue,
    },
    handlers: {
      handleSearchChange: handlers.handleSearchChange,
      handleRemoveMember: handlers.handleRemove,
      handleAddMember: handlers.handleAdd,
    },
  };
}
